// Generated by `web/scripts/build-facts.mjs` — do not edit.
//
// Every value here is read from a committed artifact, named in `source`, and
// re-checked by `web/test/explainer.test.mjs` against its own parse of the same
// artifact. Regenerate with `npm run build:facts` (the build and the tests both do
// it first), so a measurement lands in the Explainer by re-running a command, never
// by editing prose.
//
// `DEFAULT_BEAM`, the Width cap and the shipped Weight table are **not** here:
// `src/config/width.ts` and `src/config/evaluator.ts` already own them, each under a
// test that re-reads the artifact it came from.

export interface DatasetSplitFact {
  readonly first: number;
  readonly last: number;
}

export interface DatasetConfigFact {
  readonly name: string;
  readonly goal: number;
  readonly pieces: number;
  readonly cap: number;
  readonly games: number;
  readonly test: DatasetSplitFact;
  readonly tuning: DatasetSplitFact;
  readonly fingerprint: string;
}

export interface ReferenceRowFact {
  readonly config: string;
  readonly machine: string;
  readonly runtime: string;
  readonly date: string;
  readonly commit: string;
  /** The latest row verbatim (its engine.profile without the Rust "target" keyword). */
  readonly row: Readonly<Record<string, unknown>>;
}

export interface EngineFacts {
  readonly tail: { readonly pieces: number; readonly source: string };
  readonly shipped: {
    readonly evaluator: string;
    readonly table: string;
    readonly features: number;
    readonly toggles: string;
    readonly deletedToggles: readonly string[];
    readonly decidedBy: string;
    readonly source: string;
  };
  readonly dataset: {
    readonly configCount: number;
    readonly gameCount: number;
    readonly games: string;
    readonly test: DatasetSplitFact;
    readonly tuning: DatasetSplitFact;
    readonly testRange: string;
    readonly tuneRange: string;
    readonly configs: readonly DatasetConfigFact[];
  };
  readonly reference: {
    readonly status: "pending" | "measured";
    readonly rows: readonly ReferenceRowFact[];
    readonly source: string;
  };
}

export const ENGINE_FACTS: EngineFacts = {
  "tail": {
    "pieces": 3,
    "source": "engine/src/search.rs · pub const TAIL"
  },
  "shipped": {
    "evaluator": "e1",
    "table": "E1_PUBLISHED",
    "features": 8,
    "toggles": "dedup+tail+no-suicide",
    "deletedToggles": [
      "dedup-off",
      "no-suicide-off"
    ],
    "decidedBy": "§9.4 cascade on the bed above, leg: fewer evaluations per solve",
    "source": "data/measurements/ablation-ladder.json · shipped"
  },
  "dataset": {
    "configCount": 2,
    "gameCount": 2000,
    "games": "2,000",
    "test": {
      "first": 0,
      "last": 999
    },
    "tuning": {
      "first": 1000,
      "last": 1999
    },
    "testRange": "0–999",
    "tuneRange": "1,000–1,999",
    "configs": [
      {
        "name": "goal12-p100-cap7",
        "goal": 12,
        "pieces": 100,
        "cap": 7,
        "games": 2000,
        "test": {
          "first": 0,
          "last": 999
        },
        "tuning": {
          "first": 1000,
          "last": 1999
        },
        "fingerprint": "4ebdf44940134c40"
      },
      {
        "name": "goal8-p40-cap7",
        "goal": 8,
        "pieces": 40,
        "cap": 7,
        "games": 2000,
        "test": {
          "first": 0,
          "last": 999
        },
        "tuning": {
          "first": 1000,
          "last": 1999
        },
        "fingerprint": "4bf1a17b1685a774"
      }
    ]
  },
  "reference": {
    "status": "measured",
    "rows": [
      {
        "config": "goal12-p100-cap7",
        "machine": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB · Microsoft Windows 11 Pro 10.0.22621",
        "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
        "date": "2026-11-03T03:37:10Z",
        "commit": "a773ce57915edc5be8bc482800e43258a0724ead",
        "row": {
          "format": 1,
          "kind": "reference",
          "config": "goal12-p100-cap7",
          "index": 3,
          "run_id": "a773ce5/4bfa56b5/E1/w25/2026-11-03T03:37:10Z",
          "measured_at": "2026-11-03T03:37:10Z",
          "reason": "supersedes index 2: that row was measured while web/pkg/engine.wasm was still the pre-solve_batch artifact, so it named a wasm hash the page does not load; this row is the same run on the rebuilt artifact the page does load",
          "supersedes": "c8bf1a5/3cb88e38/E1/w25/2026-11-03T03:34:42Z",
          "dataset": {
            "fingerprint": "4ebdf44940134c40",
            "generator_version": 1
          },
          "behaviour": {
            "goal": 12,
            "pieces": 100,
            "cap": 7,
            "width": 25,
            "width_source": "artifact",
            "evaluator": "E1",
            "table": "E1_PUBLISHED",
            "table_fnv": "0x3a8373a0e95be4f1",
            "toggles": "shipped",
            "tail": true,
            "tail_pieces": 3
          },
          "split": {
            "first": 0,
            "last": 999,
            "n": 1000
          },
          "stats": {
            "n": 1000,
            "wins": 1000,
            "n_fail": 0,
            "win_rate": 1,
            "wilson95": [
              0.996173241514445,
              1
            ],
            "fail_lines_mean": null,
            "fail_lines_median": null,
            "evals_p50": 14169,
            "evals_p90": 15487,
            "evals_mean": 14212.985,
            "evals_max": 18363,
            "ms_p50": 5.129,
            "ms_p90": 6.547,
            "ms_max": 10.983,
            "batch_ms": 5376.014,
            "cal_ms": 386.442,
            "cal_ms_before": 383.694,
            "cal_ms_after": 389.191
          },
          "fingerprints": {
            "evals_fnv1a64": "1a075f05de2e7027",
            "lines_fnv1a64": "86418fa601f4c279",
            "evals_method": "fnv1a64-over-le-u32-seed-order",
            "lines_method": "fnv1a64-over-u8-seed-order",
            "p90_method": "nearest-rank"
          },
          "engine": {
            "commit": "a773ce57915edc5be8bc482800e43258a0724ead",
            "short": "a773ce5",
            "dirty": false,
            "wasm_sha256": "4bfa56b580d48a81adf85934049f1692fd14254702385088ef164c8531b32135",
            "wasm_bytes": 58852,
            "profile": "release: lto=fat, codegen-units=1, panic=abort, strip=true; wasm32-unknown-unknown; no wasm-bindgen, no wasm-opt",
            "toolchain": "1.99.1-x86_64-pc-windows-gnu"
          },
          "machine": {
            "cpu": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB",
            "os": "Microsoft Windows 11 Pro 10.0.22621",
            "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
            "substrate": "wasm",
            "browser_or_node": "v24.21.0 (V8 headless), not a browser",
            "rustc": "rustc 1.99.1 (58cf8f9c3 2026-10-13)",
            "node": "v24.21.0"
          },
          "labels": {
            "machine": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB · Microsoft Windows 11 Pro 10.0.22621",
            "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
            "date": "2026-11-03T03:37:10Z",
            "engine_commit": "a773ce57915edc5be8bc482800e43258a0724ead"
          }
        }
      },
      {
        "config": "goal8-p40-cap7",
        "machine": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB · Microsoft Windows 11 Pro 10.0.22621",
        "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
        "date": "2026-11-03T03:37:10Z",
        "commit": "a773ce57915edc5be8bc482800e43258a0724ead",
        "row": {
          "format": 1,
          "kind": "reference",
          "config": "goal8-p40-cap7",
          "index": 3,
          "run_id": "a773ce5/4bfa56b5/E1/w25/2026-11-03T03:37:10Z",
          "measured_at": "2026-11-03T03:37:10Z",
          "reason": "supersedes index 2: that row was measured while web/pkg/engine.wasm was still the pre-solve_batch artifact, so it named a wasm hash the page does not load; this row is the same run on the rebuilt artifact the page does load",
          "supersedes": "c8bf1a5/3cb88e38/E1/w25/2026-11-03T03:34:42Z",
          "dataset": {
            "fingerprint": "4bf1a17b1685a774",
            "generator_version": 1
          },
          "behaviour": {
            "goal": 8,
            "pieces": 40,
            "cap": 7,
            "width": 25,
            "width_source": "artifact",
            "evaluator": "E1",
            "table": "E1_PUBLISHED",
            "table_fnv": "0x3a8373a0e95be4f1",
            "toggles": "shipped",
            "tail": true,
            "tail_pieces": 3
          },
          "split": {
            "first": 0,
            "last": 999,
            "n": 1000
          },
          "stats": {
            "n": 1000,
            "wins": 1000,
            "n_fail": 0,
            "win_rate": 1,
            "wilson95": [
              0.996173241514445,
              1
            ],
            "fail_lines_mean": null,
            "fail_lines_median": null,
            "evals_p50": 9670,
            "evals_p90": 11414,
            "evals_mean": 9776.799,
            "evals_max": 14334,
            "ms_p50": 3.56,
            "ms_p90": 4.536,
            "ms_max": 8.472,
            "batch_ms": 3714.79,
            "cal_ms": 383.208,
            "cal_ms_before": 388.027,
            "cal_ms_after": 378.389
          },
          "fingerprints": {
            "evals_fnv1a64": "685753d3144408e0",
            "lines_fnv1a64": "8382f1cd4aba6800",
            "evals_method": "fnv1a64-over-le-u32-seed-order",
            "lines_method": "fnv1a64-over-u8-seed-order",
            "p90_method": "nearest-rank"
          },
          "engine": {
            "commit": "a773ce57915edc5be8bc482800e43258a0724ead",
            "short": "a773ce5",
            "dirty": false,
            "wasm_sha256": "4bfa56b580d48a81adf85934049f1692fd14254702385088ef164c8531b32135",
            "wasm_bytes": 58852,
            "profile": "release: lto=fat, codegen-units=1, panic=abort, strip=true; wasm32-unknown-unknown; no wasm-bindgen, no wasm-opt",
            "toolchain": "1.99.1-x86_64-pc-windows-gnu"
          },
          "machine": {
            "cpu": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB",
            "os": "Microsoft Windows 11 Pro 10.0.22621",
            "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
            "substrate": "wasm",
            "browser_or_node": "v24.21.0 (V8 headless), not a browser",
            "rustc": "rustc 1.99.1 (58cf8f9c3 2026-10-13)",
            "node": "v24.21.0"
          },
          "labels": {
            "machine": "AMD Ryzen 7 5700X 8-Core Processor (8C/16T), 31.9 GB · Microsoft Windows 11 Pro 10.0.22621",
            "runtime": "v24.21.0 (V8 headless, not a browser: the engine headless Chrome runs, without the DOM)",
            "date": "2026-11-03T03:37:10Z",
            "engine_commit": "a773ce57915edc5be8bc482800e43258a0724ead"
          }
        }
      }
    ],
    "source": "data/dataset/<configuration>/reference.jsonl · the latest row"
  }
};
